import React from "react";
import { Field } from "redux-form";
import PropTypes from "prop-types";
import {
  RenderInput,
  RenderSelect,
} from "../../Common/InputComponents/Inputs.jsx";
import _ from "underscore";
import {
  requiredTarget,
  requiredSeqCellAndGene,
  maxLength17,
  minLength5,
  hasValidWhitespace,
  validateCellAndGeneTherapy,
} from "../../../util/validations.js";
import {
  firstSeventeen,
  removeSpaces,
  formatUniversalAssayFluorophores,
} from "../../../util/format.js";
import {
  tooltipFluorophores,
  tooltipSequence,
} from "../../Common/Misc/Tooltips.jsx";

const fluorophoreOptions = [
  { name: "FAM", value: "FAM" },
  { name: "HEX", value: "HEX" },
  { name: "FAM + HEX", value: "FAM_HEX" },
  { name: "Cy5", value: "Cy5" },
  { name: "Cy5.5", value: "Cy5_5" },
  { name: "Cy5 + Cy5.5", value: "Cy5_Cy5_5" },
];

export const CellAndGeneTherapySequence = ({ input, index, custom }) => {
  const validationErrorDetails =
    (custom &&
      custom.validatedAssayDetails &&
      custom.validatedAssayDetails[index]) ||
    {};
  const cellAndGeneTherapySequence = input && input.name;
  const formObj = custom && custom.formObj;
  const selectedFluorophores =
    formObj &&
    formObj.values &&
    formObj.values.cellAndGeneTherapyForm &&
    formObj.values.cellAndGeneTherapyForm[index] &&
    formObj.values.cellAndGeneTherapyForm[index].cellandgenetherapysequence
      .fluorophores;

  const selectedUniversalAssayFluorophores =
    formatUniversalAssayFluorophores(formObj.values.universalAssay) || "";
  const clearValidationMessages = () => {
    custom.actions.clearValidationMessages(index);
  };

  return (
    <div>
      <div className="inputs">
        <div className="row">
          <div className="col-6">
            <div className="form-group">
              <Field
                name={`${cellAndGeneTherapySequence}.assayTargetName`}
                placeholder="17 chars. maximum"
                className="form-control"
                type="text"
                component={RenderInput}
                label="Assay Target Name:"
                validate={[requiredTarget, hasValidWhitespace, minLength5]}
                normalize={firstSeventeen}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-6">
            <div className="form-group">
              <Field
                name={`${cellAndGeneTherapySequence}.sequence`}
                className="form-control"
                type="textArea"
                rows="8"
                placeholder="e.g., GGTCAGATACAGAGATCACGTAAGGTCCTCGGTAAGTGGAGATCACAGATCGGTAAGTGGAGATCACAGATGGAGATCACAGA (minimum length = 123 base pairs)"
                component={RenderInput}
                label="Sequence:"
                validate={[requiredSeqCellAndGene, validateCellAndGeneTherapy]}
                tooltip={tooltipSequence("CopyNumberDetermination")}
                normalize={removeSpaces}
                serverValidation={validationErrorDetails}
                onChange={clearValidationMessages}
              />
            </div>
          </div>
          <div className="col-6">
            <div className="form-group">
              <Field
                name={`${cellAndGeneTherapySequence}.fluorophores`}
                className="form-control"
                component={RenderSelect}
                label="Fluorophore(s):"
                tooltip={tooltipFluorophores}
              >
                {fluorophoreOptions &&
                  fluorophoreOptions.map((option) => {
                    return (
                      <option key={option.name} value={option.value}>
                        {option.name}
                      </option>
                    );
                  })}
              </Field>

              {selectedUniversalAssayFluorophores &&
                selectedFluorophores &&
                selectedFluorophores === selectedUniversalAssayFluorophores && (
                  <small>
                    Your fluorophore choice for the Gene of Interest Assay
                    matches your fluorophore choice for the Vector Backbone
                    Assay. If the two assays are found to be multiplex
                    compatible, you will need to employ amplitude multiplexing
                    strategy in order to multiplex.
                  </small>
                )}
            </div>
          </div>
        </div>
        <br />
      </div>
    </div>
  );
};

CellAndGeneTherapySequence.propTypes = {
  //fields: PropTypes.object.isRequired,
};
